import { ItemTableConsts } from 'client/util/Constants';
import itemTableContainerCss from 'client/components/ItemTable/css/itemTableContainers.css';

export default {
  computed: {
    getItemTableContainerClass() {
      return this.inMainPanel || this.inModal
        ? itemTableContainerCss.itemTableContainer
        : itemTableContainerCss.itemTableContainerInDetailsAsidePanel;
    },
    inMainPanel() {
      if (typeof this.panelType !== 'undefined') {
        return this.panelType === ItemTableConsts.panelType.mainPanel;
      }

      if (typeof this.inDetailsAsidePanel !== 'undefined') {
        return !this.inDetailsAsidePanel;
      }
      return true;
    },
    inModal() {
      return this.panelType === ItemTableConsts.panelType.modal;
    },
  },
};
